import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RoutesFile from "./RoutesFile";
import "./App.css";
import { Toaster } from "react-hot-toast";
// Metadata (kept as requested)
const metadata = {
  name: "$MATRIX — NOT JUST A MEME. IT'S THE SIGNAL.",

  description:
    "$MATRIX is a community-driven meme token on Solana. Break free from the system. Same world. Different illusion.",

  url: "logo.png",

  icons: [
    "logo.png",
  ],
};

function App() {
  return (
    <>
      <RoutesFile />
        <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#080808",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.15)",
          },
        }}
      />
    </>
  );
}

export default App;
